// React
import React, { Component } from "react";

// React Router
import { Switch, Route } from 'react-router-dom';

// Components
import { Navbar } from '../Components';

// Views
import { Charting, Markets, Dashboard, ApiKeys, Peak } from './';

// Utils
import { PrivateRoute } from '../Utils';

// Routes
import { ClientRoutes } from '../Routes';

// Stores
import { CurrencyStore } from '../Stores';

/**********************************************************
 * 
 *  The Main class acts the parent routing class for 
 *  everything beyond the login page.
 * 
 **********************************************************/

class Main extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        //console.log('Main.constructor()');

        super(props);

        this.state = {
            theme: 'dark',
            user : null,
            details : {
                'version' : '0.15.0',
                'environment' : 'prod',
                'codename' : 'broad peak'
            },
            statuses : {}
        };

    }

/**********************************************************
 *  Lifecycle Hooks
 **********************************************************/

    // After first render (post login), navigate to /dashboard page
    // and pass the user profile in the state
    componentDidMount() {

        //console.log('Main.componentDidMount()');

        CurrencyStore.getCurrencies();

        this.getAppDetails();

        this.getServiceStatuses();

    }

/**********************************************************
 *  Functions
 **********************************************************/

    // Get the app version and env
    getAppDetails = () => {

        ClientRoutes.getAppDetails()
            .then( (details) => {
                this.setState((prevState, props) => {
                    return {
                        details : details
                    }
                });
            });

    }

    // Get the statuses of all yety services
    getServiceStatuses = () => {

        ClientRoutes.getServiceStatuses()
            .then( (statuses) => {
                this.setState((prevState, props) => {
                    return {
                        statuses : statuses
                    }
                });
            });
    }

    // Toggle theme from navbar
    toggleTheme = () => {

        var newTheme = '';

        if(this.state.theme === '')
            newTheme = 'dark';

        this.setState((prevState, props) => {
            return {
                theme : newTheme
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('Main.render()');
       
        return (

            <div className={this.state.theme}>

                <Navbar toggleTheme={this.toggleTheme} mobile={this.props.mobile} details={this.state.details} statuses={this.state.statuses}/> 

                <Switch>
                    <Route exact path={'/dashboard'} render={(props) => <Dashboard {...props} mobile={this.props.mobile} /> } />
                    <Route exact path={'/markets'} render={(props) => <Markets {...props} mobile={this.props.mobile} /> } />
                    <Route exact path={'/charts'} render={(props) => <Charting {...props} mobile={this.props.mobile} /> } />
                    <Route exact path={'/peak'} render={(props) => <Peak {...props} mobile={this.props.mobile} /> } />
                    <PrivateRoute exact path='/apikeys' render={(props) => <ApiKeys {...props} mobile={this.props.mobile} />} />
                </Switch>

            </div>

        );
    }
}

export default Main;





// WEBPACK FOOTER //
// ./src/Views/Main.js